import { IdType, Row } from 'react-table';

const getMatchForAlphaNumSort = <T extends Record<string, unknown>>(value?: Record<IdType<T>, any>[IdType<T>]) => {
  if (!value) return '';
  return value.match(/\d+|\D+/g) || '';
};

const getStringFromArray = (value: string | Array<string>) => {
  if (typeof value === 'string') {
    return value;
  }
  return value.join('');
};

/** Original algorithm can be viewed here https://www.tutorialspoint.com/how-to-sort-mixed-numeric-alphanumeric-array-in-javascript */
export function customAlphaNumSort<T extends Record<string, unknown>>(
  row1: Row<T>,
  row2: Row<T>,
  columnId: IdType<T>,
): number {
  // Grab the value from each row and transforms into lowerCase if value is present
  const valueA = row1.values[columnId] && row1.values[columnId].toString().toLowerCase();
  const valueB = row2.values[columnId] && row2.values[columnId].toString().toLowerCase();

  // match the values have digits or charcters. If not, the value is considered empty.
  const aPart = getMatchForAlphaNumSort(valueA);
  const bPart = getMatchForAlphaNumSort(valueB);

  // Compare the characters of both the values
  let i = 0;
  const len = Math.min(aPart.length, bPart.length);
  while (i < len && aPart[i] === bPart[i]) {
    i++;
  }
  // if each character has been the same so far and increment equals the smallest length between the two values, we sort based on length.
  if (i === len) {
    return aPart.length - bPart.length;
  }
  // Since row values are strings, we need to check if the values have numbers
  const isNumber = (value: string | number | undefined): boolean => {
    if (value) {
      return (+value).toString() === value;
    }
    return false;
  };
  // if the value is a number, calculate which number takes prescedence
  if (isNumber(aPart[i]) && isNumber(bPart[i])) {
    return aPart[i] - bPart[i];
  }

  return getStringFromArray(aPart).localeCompare(getStringFromArray(bPart));
}

export function customUpdatedTimestampSort<T extends Record<string, unknown>>(row1: Row<T>, row2: Row<T>): number {
  const valueA = (row1.original?.updatedTimestamp as string) ?? '';
  const valueB = (row2.original?.updatedTimestamp as string) ?? '';

  if (valueA > valueB) return 1;
  else if (valueA < valueB) return -1;
  return 0;
}
